/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NutritionSupplementsViewFragmentAliases {
  CONTEXTUAL_SUPPLEMENTS = 'contextual-supplements',
  FIELD_ADMINISTRATION = 'field-administration',
  FIELD_DILUENT = 'field-diluent',
  FIELD_DILUENT_DOSE = 'field-diluent-dose',
  FIELD_DILUENT_UNIT_MEASURE = 'field-diluent-unit-measure',
  FIELD_DILUENT_VOLUME = 'field-diluent-volume',
  FIELD_DURATION = 'field-duration',
  FIELD_END_DATE = 'field-end-date',
  FIELD_HOURS = 'field-hours',
  FIELD_INFUSION_DEVICE = 'field-infusion-device',
  FIELD_INFUSION_RATE = 'field-infusion-rate',
  FIELD_INFUSION_RATE_UNIT_MEASURE = 'field-infusion-rate-unit-measure',
  FIELD_INTERVAL = 'field-interval',
  FIELD_ITEM = 'field-item',
  FIELD_ITEM_DOSE = 'field-item-dose',
  FIELD_ITEM_UNIT_MEASURE = 'field-item-unit-measure',
  FIELD_JUSTIFICATION = 'field-justification',
  FIELD_NUTRITION = 'field-nutrition',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PREPARATION_GUIDANCE = 'field-preparation-guidance',
  FIELD_PRESCRIBER_DATE = 'field-prescriber-date',
  FIELD_PRESCRIBER_NAME = 'field-prescriber-name',
  FIELD_ROUTE = 'field-route',
  FIELD_STAGE_INFUSION_DURATION = 'field-stage-infusion-duration',
  FIELD_START_DATE = 'field-start-date',
  FORM_ADDITIONAL_INFORMATION = 'form-additional-information',
  FORM_MAIN_INFORMATIONS = 'form-main-informations',
  FORM_PERIOD_OF_VALIDITY = 'form-period-of-validity',
  FRAGMENT_REFERENCE_BAR_HEADER = 'fragment-reference-bar-header',
  INPUT_END_DATE = 'input-end-date',
  INPUT_START_DATE = 'input-start-date',
  LAYOUT_SUPPLEMENTS = 'layout-supplements',
  LOADER = 'loader',
  PANEL_CONTENT = 'panel-content',
  PANEL_LOADER = 'panel-loader',
  SECTION_ADDITIONAL_INFORMATION = 'section-additional-information',
  SECTION_MAIN_INFORMATIONS = 'section-main-informations',
  SECTION_PERIOD_OF_VALIDITY = 'section-period-of-validity',
  SUPPRESS_HEADING_MARGIN_ADDITIONAL_INFORMATION = 'suppress-heading-margin-additional-information',
  SUPPRESS_HEADING_MARGIN_MAIN_INFORMATIONS = 'suppress-heading-margin-main-informations',
  SUPPRESS_HEADING_MARGIN_PERIOD_OF_VALIDITY = 'suppress-heading-margin-period-of-validity',
  TEXT_ADMINISTRATION = 'text-administration',
  TEXT_DILUENT = 'text-diluent',
  TEXT_DILUENT_DOSE = 'text-diluent-dose',
  TEXT_DILUENT_UNIT_MEASURE = 'text-diluent-unit-measure',
  TEXT_DILUENT_VOLUME = 'text-diluent-volume',
  TEXT_DURATION = 'text-duration',
  TEXT_HOURS = 'text-hours',
  TEXT_INFUSION_DEVICE = 'text-infusion-device',
  TEXT_INFUSION_RATE = 'text-infusion-rate',
  TEXT_INFUSION_RATE_UNIT_MEASURE = 'text-infusion-rate-unit-measure',
  TEXT_INTERVAL = 'text-interval',
  TEXT_ITEM = 'text-item',
  TEXT_ITEM_DOSE = 'text-item-dose',
  TEXT_ITEM_UNIT_MEASURE = 'text-item-unit-measure',
  TEXT_JUSTIFICATION = 'text-justification',
  TEXT_NUTRITION = 'text-nutrition',
  TEXT_NUTRITIONAL_CALORIC_PROFILE = 'text-nutritional-caloric-profile',
  TEXT_OBSERVATION = 'text-observation',
  TEXT_PREPARATION_GUIDANCE = 'text-preparation-guidance',
  TEXT_PRESCRIBER_DATE = 'text-prescriber-date',
  TEXT_PRESCRIBER_NAME = 'text-prescriber-name',
  TEXT_STAGE_INFUSION_DURATION = 'text-stage-infusion-duration',
}
export { NutritionSupplementsViewFragmentAliases };
